import { Image, LinkBase, Text } from '@belong/ui';
import clsx from 'clsx';
import css from './san-diego-short-term-rentals-banner.module.css';
import { SAN_DIEGO_SHORT_TERM_RENTALS_BANNER_STRINGS } from './san-diego-short-term-rentals-banner.strings';

export function SanDiegoShortTermRentalsBanner() {
  return (
    <LinkBase
      href={SAN_DIEGO_SHORT_TERM_RENTALS_BANNER_STRINGS['link']}
      target="_blank"
    >
      <div
        className={clsx(
          css.container,
          'border-gray bg-light-gray duration-hover hover:border-dark-gray group mx-auto w-full overflow-hidden rounded border border-solid transition-all hover:cursor-pointer',
        )}
      >
        <div className="flex flex-col lg:flex-row-reverse">
          <div
            className={clsx(
              css.imageContainer,
              'border-gray duration-hover group-hover:border-dark-gray flex flex-row border-solid transition-all',
            )}
          >
            <Image
              src="homeowner-lp/san_diego_short_term_rentals_banner_svg_m.svg"
              alt={SAN_DIEGO_SHORT_TERM_RENTALS_BANNER_STRINGS['image.alt']}
              className="block lg:absolute lg:hidden"
            />
            <Image
              src="homeowner-lp/san_diego_short_term_rentals_banner_svg.svg"
              alt={SAN_DIEGO_SHORT_TERM_RENTALS_BANNER_STRINGS['image.alt']}
              className="absolute hidden lg:relative lg:block"
            />
          </div>
          <div className="px-2sm py-lg lg:px-xl lg:py-md container flex flex-col items-center text-center lg:items-start lg:justify-center lg:text-left">
            <Text
              variant="body"
              className="mb-xs text-navy sm:absolute sm:hidden"
            >
              {SAN_DIEGO_SHORT_TERM_RENTALS_BANNER_STRINGS['title_line_one']}
              <br />
              {
                SAN_DIEGO_SHORT_TERM_RENTALS_BANNER_STRINGS[
                  'title_line_two_first_phrase'
                ]
              }
              <b>
                {
                  SAN_DIEGO_SHORT_TERM_RENTALS_BANNER_STRINGS[
                    'title_line_two_bold_phrase'
                  ]
                }
              </b>
              {
                SAN_DIEGO_SHORT_TERM_RENTALS_BANNER_STRINGS[
                  'title_line_two_last_phrase'
                ]
              }
            </Text>
            <Text
              variant="h3"
              className="mb-xs text-navy absolute hidden sm:relative sm:block"
            >
              {SAN_DIEGO_SHORT_TERM_RENTALS_BANNER_STRINGS['title_line_one']}
              <br />
              {
                SAN_DIEGO_SHORT_TERM_RENTALS_BANNER_STRINGS[
                  'title_line_two_first_phrase'
                ]
              }
              <b>
                {
                  SAN_DIEGO_SHORT_TERM_RENTALS_BANNER_STRINGS[
                    'title_line_two_bold_phrase'
                  ]
                }
              </b>
              {
                SAN_DIEGO_SHORT_TERM_RENTALS_BANNER_STRINGS[
                  'title_line_two_last_phrase'
                ]
              }
            </Text>
            <Text variant="p1" className="text-navy sm:absolute sm:hidden">
              {SAN_DIEGO_SHORT_TERM_RENTALS_BANNER_STRINGS['body']}
            </Text>
            <Text
              variant="body"
              className="text-navy absolute hidden sm:relative sm:block"
            >
              {SAN_DIEGO_SHORT_TERM_RENTALS_BANNER_STRINGS['body']}
            </Text>
            <Text
              variant="body"
              fontWeight="semibold"
              className={clsx(
                'mt-sm text-navy duration-hover group-hover:text-dark-navy lg:mt-md transition-all lg:self-end',
              )}
            >
              {SAN_DIEGO_SHORT_TERM_RENTALS_BANNER_STRINGS['read_more']}
            </Text>
          </div>
        </div>
      </div>
    </LinkBase>
  );
}
